import { Field, TextInput, TextArea, SectionCard } from "./_shared";
import ImageUploadField from "./ImageUploadField";

export default function EditHero({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <SectionCard title="Hero (Topo)">
      <div className="space-y-5">
        <Field label="Overline (texto pequeno acima)">
          <TextInput value={value.overline} onChange={(v) => set("overline", v)} testId="hero-overline-input" />
        </Field>
        <Field label="Título principal (linha 1)">
          <TextInput value={value.title} onChange={(v) => set("title", v)} testId="hero-title-input" />
        </Field>
        <Field label="Destaque do título (linha 2, em itálico)">
          <TextInput value={value.titleHighlight} onChange={(v) => set("titleHighlight", v)} testId="hero-title-highlight-input" />
        </Field>
        <Field label="Subtítulo / parágrafo">
          <TextArea value={value.subtitle} onChange={(v) => set("subtitle", v)} rows={4} testId="hero-subtitle-input" />
        </Field>
        <ImageUploadField label="Imagem principal" value={value.image} onChange={(v) => set("image", v)} testId="hero-image" />
        <div className="grid sm:grid-cols-2 gap-5">
          <Field label="CTA principal (texto)">
            <TextInput value={value.ctaPrimary} onChange={(v) => set("ctaPrimary", v)} testId="hero-cta-primary-input" />
          </Field>
          <Field label="CTA secundário (texto)">
            <TextInput value={value.ctaSecondary} onChange={(v) => set("ctaSecondary", v)} testId="hero-cta-secondary-input" />
          </Field>
        </div>
      </div>
    </SectionCard>
  );
}
